
import { Stack, Typography, Button, Box, useTheme, ButtonBase, Tooltip } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ProductSpecification from './ProductSpecification';
import ProductDescription from './ProductDescription';
import ScrollBox from '../../../components/ScrollBox';
import ImageGallery from './ImageGallery';
import BackButton from '../../../components/BackButton';
import LabelTxt from '../../../components/LabelTxt';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useQuery, useQueryClient } from 'react-query';
import QueryKey from '../../../utils/QueryKey';
import { formatDateWithJs, formatName, isEmpty, isNotEmpty, makeTxtOverFLow, NumberFormatter } from '../../../utils/format';
import { deleteProdServ, getSingleProdServ, putProdApprServ } from '../../../services/amtc-service';
import { useAuthContext } from '../../../context/AuthContext';
import { customAlert, notify } from '../../../components/notify';
import route from '../../../utils/Routes';
import PathBtns from '../../../components/PathBtns';
import industryIcon from '../../../assets/svg/industry-factory-color-icon 1.svg';
import downlodicon from '../../../assets/svg/downloadIcon.svg';
import constants from '../../../utils/Constants';
import { IoIosArrowDroprightCircle } from "react-icons/io";
import ArchiveIcon from '@mui/icons-material/Archive';
import UnarchiveIcon from '@mui/icons-material/Unarchive';
import NotesMdl from '../../../components/NotesMdl';
import RemarksMdl from '../../../components/RemarksMdl';
import { rmvProdFromCatalogServ } from '../../../services/com-service';
import RmvProdCatalogPopup from './RmvProdCatalogPopup';

function AmtcProdInfoPg({ type = "amtc" }) {
    const navigate = useNavigate();
    const theme = useTheme();
    const queryClient = useQueryClient();
    const { setLoadingScreen, ctxtUser, setNavComValue } = useAuthContext();
    const [searchParams] = useSearchParams();
    const qProdId = searchParams.get("prodId");
    const comId = searchParams.get("comId");
    const location = useLocation()

    const { isLoading, isError, error, data: prodData } = useQuery([QueryKey.amtcProdInfo, qProdId, type, comId], () => getSingleProdServ(qProdId, type, comId),
        {
            enabled: isNotEmpty(qProdId),
            refetchOnMount: true,
            refetchOnWindowFocus: false,
        })
    const typoHeadStyle = { borderColor: "rgb(0,0,0,0.1)", fontSize: 12, padding: 0.5, color: "rgb(0,0,0,0.6)", display: "inline-block", width: 140 }
    const typostyle = { borderColor: "rgb(0,0,0,0.1)", fontSize: 12, padding: 0.5, display: "inline-block" };

    const pathBtnsArr = type === "amtc" ? [{
        label: "Category",
        handleClick: () => navigate(route.aCataLog)
    }, {
        label: prodData?.parCatName,
        handleClick: () => navigate(`${route.aSubcategory}/?catId=${prodData?.parCategoryId}&catName=${prodData?.parCatName}`)
    }, {
        label: prodData?.subCatName,
        handleClick: () => navigate(`${route.aProducts}/?subCatId=${prodData?.subCategoryId1}`)
    }, {
        label: prodData?.prodName,
        handleClick: () => { }
    }] : [{
        label: "Category",
        handleClick: () => navigate(`${route.aCompany}/?comId=${comId}&tab=2`)
    }, {
        label: prodData?.parCatName,
        handleClick: () => navigate(`${route.aComSubcategory}/?catId=${prodData?.parCategoryId}&catName=${prodData?.parCatName}&comId=${comId}`)
    }, {
        label: prodData?.subCatName,
        handleClick: () => navigate(`${route.aComProdList}/?subCatId=${prodData?.subCategoryId1}&comId=${comId}`)
    }, {
        label: prodData?.prodName,
        handleClick: () => { }
    }]
    const [notesMdl, setNotesMdl] = useState(false);
    const handleNotesMdlClose = () => setNotesMdl(false);
    const handleNotesMdlOpen = () => {
        setNotesMdl(true);
    }

    const [rmvOpen, setRmvOpen] = useState(false);
    const handleRmvMdlClose = () => setRmvOpen(false);
    const handleRmvMdlOpen = () => setRmvOpen(true);
    // [{
    //     label: "Category",
    //     handleClick: () => navigate(`${route.aCompany}/?comId=${comId}&tab=2`)
    // }, {
    //     label: prodData?.parCatName,
    //     handleClick: () => navigate(`${route.aComSubcategory}/?catId=${prodData?.parCategoryId}&catName=${prodData?.parCatName}&comId=${comId}`)
    // }, {
    //     label: prodData?.subCatName,
    //     handleClick: () => navigate(`${route.aComProdList}/?subCatId=${prodData?.subCategoryId1}&comId=${comId}`)
    // }, {
    //     label: prodData?.prodName,
    //     handleClick: () => { }
    // }]

    useEffect(() => {
        setLoadingScreen(isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    useEffect(() => {
        if (!qProdId) {
            navigate("/", { replace: true });
        }
    }, [qProdId, navigate]);

    useEffect(() => {
        if (type === "com") {
            if (!comId) {
                navigate("/", { replace: true });
            }
        }
    }, [type, comId, navigate]);

    useEffect(() => {
        if (!prodData)
            return;

        if (ctxtUser?.userType !== constants.admin && prodData?.isDelete === 1) {
            navigate("/", { replace: true });
        }

    }, [prodData, navigate, ctxtUser]);

    useEffect(() => {
        setNavComValue({ comId })
        return () => setNavComValue({ comId: "" }); // Reset when leaving the page
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, comId]);



    function handleDownloadClick(url) {
        window.open(url, "_blank", "noopener,noreferrer");
    }

    function handleEditProdClick() {
        navigate(route.aEditProd, { state: { prodId: qProdId } });
    }
    function handleAllInfoEditProdClick() {
        navigate(route.aApprEditProd, { state: { prodId: qProdId } });
    }


    function handleUpdateStockClick() {
        navigate(route.aUpdateProdStock, { state: { prodId: qProdId } });
    }

    function handleViewStockListClick() {
        navigate(`${route.aProdStockList}/?prodId=${qProdId}`);
    }

    async function handleMdlSave({ editRemarks }) {
        setNotesMdl(false)
        setLoadingScreen(true);
        try {
            const { message } = await putProdApprServ(qProdId, 2, editRemarks);
            queryClient.invalidateQueries();
            notify("success", message);
            navigate(`${route.aProdApprWaitList}`, { replace: true })
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    }

    async function handleProdApprClick() {
        setLoadingScreen(true);
        try {
            const { message } = await putProdApprServ(qProdId, 1);
            notify("success", message);
            queryClient.invalidateQueries();
            navigate(`${route.aProduct}/?prodId=${qProdId}`, { replace: true });
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    }

    async function handleArchiveClick(status) {
        setLoadingScreen(true);
        try {
            const { message } = await deleteProdServ({ amtcProdIdStrg: qProdId, status });
            notify("success", message);
            queryClient.invalidateQueries();
            navigate(`${route.aProduct}/?prodId=${qProdId}`, { replace: true });
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    }

    async function handleRmvProdFromCatalogClick() {
        handleRmvMdlClose()
        setLoadingScreen(true);
        try {
            const { message } = await rmvProdFromCatalogServ({ amtcProdIdStrg: qProdId, comId: comId, comProdIdStrg: prodData?.comProdIdStrg });
            notify("success", message);
            queryClient.invalidateQueries();
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    }

    function handleUpdateAgreeClick() {
        navigate(route.aUpdateProdAgree, { state: { prodId: qProdId, comId } });
    }

    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }

    return (<>
        {prodData ? <ScrollBox height={"100%"} width={"100%"}>
            <Stack direction={"row"} spacing={2} alignItems={"center"} justifyContent={"space-between"} mb={2} pr={2}>
                <Stack direction={"row"} alignItems={"center"}>
                    <BackButton />
                    <PathBtns btnsArr={pathBtnsArr} />
                    {prodData?.isApproved === 0 && <Box sx={{ fontSize: 12, bgcolor: "orange", px: 2, borderRadius: 10 }}>Awaiting Approval</Box>}
                    {prodData?.isApproved === 2 && <Box sx={{ fontSize: 12, bgcolor: "red", color: "white", px: 2, borderRadius: 10 }}>Rejected</Box>}
                </Stack>
                <Stack direction={"row"} justifyContent="end" alignItems={"center"}  >
                    {(ctxtUser?.userType === constants.admin && type === "amtc") &&
                        <Stack direction={"row"} alignItems={"center"} gap={2} >
                            {prodData?.isDelete === 0 ? <Button variant='outlined' onClick={() => handleArchiveClick(1)} sx={{
                                color: "red", borderColor: "red", height: 30
                            }} startIcon={<ArchiveIcon />}>
                                Archive</Button> : <Button variant='outlined' onClick={() => handleArchiveClick(0)} sx={{
                                    color: "green", borderColor: "green", height: 30
                                }} startIcon={<UnarchiveIcon />}>
                                Unarchive</Button>}
                            <Button variant='outlined' onClick={handleEditProdClick} sx={{
                                color: theme?.palette?.custom?.btn, borderColor: theme?.palette?.custom?.btn, height: 30
                            }}>
                                Edit Product</Button>
                        </Stack>}
                    {(type === "created") && <Button variant='outlined' onClick={handleAllInfoEditProdClick} sx={{
                        color: theme?.palette?.custom?.btn, borderColor: theme?.palette?.custom?.btn, height: 30
                    }}>
                        Edit Product</Button>}
                    {type === "com" && (isEmpty(prodData?.comProdIdStrg) && <Stack sx={{
                        borderRadius: 1, backgroundColor: "rgba(255, 183, 3, 1)", fontSize: 13, width: 230,
                        color: "rgba(7, 42, 200, 1)", height: 30
                    }} alignItems={"center"} justifyContent={"center"}>
                        Not in Company Catalogue!
                    </Stack>)}
                    {type === "com" && ((prodData?.isExpired === 1) && <Stack sx={{
                        borderRadius: 1, backgroundColor: "rgba(247, 64, 64, 0.5)", fontSize: 13, width: 230,
                        color: "rgba(7, 42, 200, 1)", height: 30, ml: 2
                    }} alignItems={"center"} justifyContent={"center"}>
                        Product agreed period is over!
                    </Stack>)}
                    {(ctxtUser?.userType === constants.admin && type === "com" && isNotEmpty(prodData?.comProdIdStrg)) &&
                        <Button variant='outlined' onClick={handleRmvMdlOpen} sx={{
                            color: "red", borderColor: "red", height: 30, ml: 2
                        }}>
                            Remove Product</Button>}
                </Stack>

                {/* {(type === "amtc" && apprType !== "req") && <Stack direction={"row"} justifyContent="end" alignItems={"center"}  >
                    {ctxtUser?.userType === constants.admin && <Button variant='outlined' onClick={handleEditProdClick} sx={{
                        color: theme?.palette?.custom?.btn, borderColor: theme?.palette?.custom?.btn, height: 30
                    }}>
                        Edit Product</Button>}
                </Stack>} */}
            </Stack>
            <Stack direction={"row"} sx={{ marginBottom: 1, width: "100%", height: "100%" }} spacing={5} >
                <Stack direction={"column"} width={"30%"} >
                    <ImageGallery prodImgs={prodData?.prodImgs} />
                </Stack>
                <Stack direction={"column"} width={"40%"} >
                    <Typography sx={{ fontSize: 15, fontWeight: 500, marginBottom: 1, mt: 1 }}>{prodData?.prodName}</Typography>
                    <LabelTxt typoname={"AMTC Product ID"} typodetail={prodData?.amtcProdIdStrg} overflow={90} namestyle={typoHeadStyle} detailstyle={typostyle} />
                    {type === "com" && (isNotEmpty(prodData?.comProdIdStrg) ? <LabelTxt typoname={"Material Code"} typodetail={prodData?.comProdIdStrg} overflow={90}
                        namestyle={typoHeadStyle} detailstyle={typostyle} /> : <></>)}
                    {(type === "req" || type === "created") && <LabelTxt typoname={"Created By"} typodetail={formatName(prodData?.cByFName, prodData?.cByLName)} overflow={90}
                        namestyle={typoHeadStyle} detailstyle={typostyle} />}
                    <Typography sx={{ fontSize: 15, fontWeight: 500, mt: 1.5 }}>About this Product</Typography>
                    <Typography sx={{ fontSize: 14, fontWeight: 500, marginBottom: 0.5, mt: 1 }}>Product Specification</Typography>
                    <ProductSpecification specs={prodData?.prodSpecsJs || []} />
                    <ProductDescription details={prodData?.prodDesc || ""} mt={1} />
                </Stack>
                <Stack width={"30%"} height={"100%"} pr={1} gap={1}>
                    <Box sx={{ border: 1, borderColor: "rgba(0,0,0,0.1)", borderRadius: 2, pt: 1, px: 3, height: 280 }}>
                        <Typography sx={{ fontSize: 14, fontWeight: 500, }}> Manufacturers</Typography>
                        <Stack direction={"row"} spacing={2} alignItems="center" sx={{ paddingY: 1 }}>
                            <img src={industryIcon} alt="industimg1" style={{ width: 25, }} />
                            <Tooltip title={prodData?.mfrName}>
                                <Typography sx={{ fontSize: 12, fontWeight: 400, color: "rgba(0,0,0,0.8)" }}> {makeTxtOverFLow(prodData?.mfrName, 38)}</Typography>
                            </Tooltip>
                        </Stack>
                        <Box border={0.3} borderColor="rgba(0,0,0,0.08)" width={"100%"} my={1} />
                        <Typography sx={{ fontSize: 14, fontWeight: 500 }}> Attachments</Typography>
                        <ScrollBox height={"60%"}>
                            {(prodData?.prodFiles || []).map((i) => <Stack key={i?.id} direction={"row"} alignItems="center" justifyContent={"space-between"}
                                width={"100%"} sx={{ border: "1px dashed rgba(0,0,0,0.1)", borderRadius: 3, mb: 0.4 }}>
                                <Typography sx={{ fontSize: 12, pl: 1, fontWeight: 400, color: "rgba(0,0,0,0.8)" }}>{makeTxtOverFLow(i?.fileName, 31)} </Typography>
                                <Button onClick={() => handleDownloadClick(i?.fileUrl)}>
                                    <img src={downlodicon} alt="downlodicon" style={{ width: 25 }} />
                                </Button>
                            </Stack>)}
                        </ScrollBox>
                    </Box>

                    {(type === "amtc" || type === "req" || type === "created") && <Stack border={1} borderColor="rgba(0,0,0,0.1)" borderRadius={2} width={"100%"} fontSize={15} py={1} px={3} gap={1}>
                        <Stack direction={"row"} alignItems="center" justifyContent={"space-between"} width={"100%"}>
                            <Typography sx={{ fontSize: 12, fontWeight: 400, color: "rgba(0,0,0,0.8)", }}>Blocked Qty </Typography>
                            <Typography sx={{ fontSize: 12, fontWeight: 400, backgroundColor: "rgba(253, 240, 213, 1)", }}>&nbsp;{prodData?.blockedQty}&nbsp;</Typography>
                        </Stack>
                        <Stack direction={"row"} alignItems="center" justifyContent={"space-between"} width={"100%"}>
                            <Typography sx={{ fontSize: 12, fontWeight: 400, color: "rgba(0,0,0,0.8)", }}>Avl Quantity </Typography>
                            <Typography sx={{ fontSize: 12, fontWeight: 400, backgroundColor: "rgba(253, 240, 213, 1)", }}>&nbsp;{prodData?.avlQty}&nbsp;</Typography>
                        </Stack>
                        {ctxtUser?.userType !== constants.store && <Stack direction={"row"} alignItems="center" justifyContent={"space-between"} width={"100%"}>
                            <Typography sx={{ fontSize: 12, fontWeight: 400, color: "rgba(0,0,0,0.8)", }}>Price (OMR)</Typography>
                            <Typography sx={{ fontSize: 12, fontWeight: 400, backgroundColor: "rgba(253, 240, 213, 1)", }}>&nbsp;{NumberFormatter(prodData?.amtcPrice)}&nbsp;</Typography>
                        </Stack>}
                        {ctxtUser?.userType !== constants.store && <Stack direction={"row"} alignItems="center" justifyContent={"space-between"} width={"100%"}>
                            <Typography sx={{ fontSize: 12, fontWeight: 400, color: "rgba(0,0,0,0.8)", }}>Tax (%)</Typography>
                            <Typography sx={{ fontSize: 12, fontWeight: 400, backgroundColor: "rgba(253, 240, 213, 1)", }}>&nbsp;{prodData?.amtcTax}&nbsp;</Typography>
                        </Stack>}
                    </Stack>}

                    {(type === "amtc") && <Stack>
                        {(ctxtUser?.userType !== constants.store && ctxtUser?.userType !== constants.accounts) && <ButtonBase onClick={handleViewStockListClick}
                            sx={{
                                display: "block", width: "100%", border: 1, borderColor: "rgba(0,0,0,0.1)", borderRadius: 2, fontSize: 15,
                                py: 1, px: 3, textAlign: "left", transition: "all 0.3s ease", my: 1,
                                "&:hover": {
                                    backgroundColor: "rgba(0,0,0,0.05)", boxShadow: "0px 4px 10px rgba(0,0,0,0.1)"
                                },
                            }}>
                            <Stack direction={"row"} alignItems="center" justifyContent={"space-between"} gap={1}>
                                <Typography sx={{ fontSize: 12, pl: 1, fontWeight: 550, color: "rgba(0,0,0,0.8)", }}>VIEW STOCK BY COMPANY</Typography>
                                <IoIosArrowDroprightCircle size={20} color={theme?.palette?.custom?.btn} />
                            </Stack>
                        </ButtonBase>}
                        <Stack width={"100%"} alignItems={"center"}>
                            {ctxtUser?.userType === constants.admin && <Button variant="contained" onClick={handleUpdateStockClick} sx={{
                                borderRadius: 2, backgroundColor: "rgba(255, 183, 3, 1)", fontSize: 13, width: 230,
                                color: "rgba(7, 42, 200, 1)"
                            }} >
                                UPDATE STOCK DETAILS
                            </Button>}
                        </Stack>
                    </Stack>}
                    {type === "req" && <Stack direction={"row"} width={"100%"} alignItems={"center"} justifyContent={"end"}>
                        <Button variant="outlined" onClick={handleNotesMdlOpen} sx={{
                            fontWeight: 600, height: 40, width: 100, borderRadius: 2, backgroundColor: theme.palette.custom.grey,
                            color: theme.palette.custom.btn, mr: 2,
                        }}>REJECT</Button>
                        <Button variant="contained" onClick={handleProdApprClick} sx={{
                            borderRadius: 2, backgroundColor: "rgba(255, 183, 3, 1)", width: 100, height: 40, fontWeight: 600,
                            color: "rgba(7, 42, 200, 1)"
                        }} >
                            APPROVE</Button>
                    </Stack>}
                    {(type === "created" && prodData?.isApproved === 2) && <Stack width={"100%"} >
                        <Stack border={1} borderColor="rgba(0,0,0,0.1)" borderRadius={2} width={"100%"} mb={1} fontSize={15} py={1} px={3} gap={1}>
                            <Typography sx={{ fontSize: 14, fontWeight: 500 }}>Rejected By</Typography>
                            <Typography sx={{ fontSize: 12, whiteSpace: 'pre-wrap' }}>{formatName(prodData?.rjcUserFName, prodData?.rjcUserLName) + ` (${prodData?.rjcUserUsername})`}</Typography>
                        </Stack>
                        <Stack border={1} borderColor="rgba(0,0,0,0.1)" borderRadius={2} width={"100%"} fontSize={15} py={1} px={3} gap={1}>
                            <Typography sx={{ fontSize: 14, fontWeight: 500 }}>Rejected Remark</Typography>
                            <Typography sx={{ fontSize: 12, whiteSpace: 'pre-wrap' }}>{isNotEmpty(prodData?.rjcRemarks) ? prodData?.rjcRemarks : "NA"}</Typography>
                        </Stack>
                    </Stack>}
                    {type === "com" && (isNotEmpty(prodData?.comProdIdStrg) ? <Stack>
                        <Stack border={1} borderColor="rgba(0,0,0,0.1)" borderRadius={2} width={"100%"} fontSize={15} py={1} px={3} gap={1}>
                            <Stack direction={"row"} alignItems="center" justifyContent={"space-between"} width={"100%"}>
                                <Typography sx={{ fontSize: 12, fontWeight: 400, color: "rgba(0,0,0,0.8)", }}>Agreed Period </Typography>
                                <Typography sx={{ fontSize: 12, fontWeight: 400, backgroundColor: "rgba(253, 240, 213, 1)", }}>&nbsp;{`${formatDateWithJs(prodData?.agreedFrom)} to ${formatDateWithJs(prodData?.agreedTo)}`}&nbsp;</Typography>
                            </Stack>
                            <Stack direction={"row"} alignItems="center" justifyContent={"space-between"} width={"100%"}>
                                <Typography sx={{ fontSize: 12, fontWeight: 400, color: "rgba(0,0,0,0.8)", }}>Agreed Quantity </Typography>
                                <Typography sx={{ fontSize: 12, fontWeight: 400, backgroundColor: "rgba(253, 240, 213, 1)", }}>&nbsp;{prodData?.agreedQty}&nbsp;</Typography>
                            </Stack>
                            <Stack direction={"row"} alignItems="center" justifyContent={"space-between"} width={"100%"}>
                                <Typography sx={{ fontSize: 12, fontWeight: 400, color: "rgba(0,0,0,0.8)", }}>Price Agreement Id</Typography>
                                <Typography sx={{ fontSize: 12, fontWeight: 400, backgroundColor: "rgba(253, 240, 213, 1)", }}>&nbsp;{prodData?.priceAgreeId}&nbsp;</Typography>
                            </Stack>
                            <Stack direction={"row"} alignItems="center" justifyContent={"space-between"} width={"100%"}>
                                <Typography sx={{ fontSize: 12, fontWeight: 400, color: "rgba(0,0,0,0.8)", }}>Agreed Price  (OMR)</Typography>
                                <Typography sx={{ fontSize: 12, fontWeight: 400, backgroundColor: "rgba(253, 240, 213, 1)", }}>&nbsp;{NumberFormatter(prodData?.AgreedPrice)}&nbsp;</Typography>
                            </Stack>
                            <Stack direction={"row"} alignItems="center" justifyContent={"space-between"} width={"100%"}>
                                <Typography sx={{ fontSize: 12, fontWeight: 400, color: "rgba(0,0,0,0.8)", }}>Tax (%)</Typography>
                                <Typography sx={{ fontSize: 12, fontWeight: 400, backgroundColor: "rgba(253, 240, 213, 1)", }}>&nbsp;{prodData?.comProdTax}&nbsp;</Typography>
                            </Stack>
                        </Stack>
                        <Stack width={"100%"} alignItems={"center"} mt={2}>
                            {ctxtUser?.userType === constants.admin && <Button variant="contained" onClick={handleUpdateAgreeClick} sx={{
                                borderRadius: 2, backgroundColor: "rgba(255, 183, 3, 1)", fontSize: 13, width: 230,
                                color: "rgba(7, 42, 200, 1)"
                            }} >
                                UPDATE AGREEMENT DETAILS
                            </Button>}
                        </Stack>
                    </Stack> : <></>)}
                </Stack>
            </Stack>
            <RmvProdCatalogPopup open={rmvOpen} handleClose={handleRmvMdlClose} handleRmvClick={handleRmvProdFromCatalogClick} />
            <RemarksMdl modalOpen={notesMdl} handleModalClose={handleNotesMdlClose} handleMdlSave={handleMdlSave} payload={prodData} />
        </ScrollBox> : <Typography component={'h1'}>Data Not Found</Typography>}
    </>

    )
}
export default AmtcProdInfoPg